import { useTranslation } from 'react-i18next';
import { chauffeurWhy } from '@/mocks/corporateChauffeurData';

export default function WhyButlerWorks() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[900px] mx-auto px-8">
        <div className="text-center mb-14">
          {String(t('corporateChauffeur.why.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('corporateChauffeur.why.title')}
          </h2>
          {String(t('corporateChauffeur.why.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto mb-5"></div>
          {String(t('corporateChauffeur.why.lead1')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">{__s}</p>))}
          {String(t('corporateChauffeur.why.lead2')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto mt-3">{__s}</p>))}
        </div>

        <div className="space-y-6">
          {chauffeurWhy.map((item, idx) => (
            <div
              key={idx}
              className="flex flex-col md:flex-row items-start gap-5 p-6 bg-background-50 border border-background-200/60"
            >
              <div className="w-11 h-11 rounded-full bg-accent-500/8 border border-accent-500/20 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-accent-500 text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-3">
                  {t(`corporateChauffeur.why.${idx}.title`)}
                </h3>
                <p className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed">
                  {t(`corporateChauffeur.why.${idx}.desc`)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}